import { BUTTONS_SHOWN, BUTTONS_HIDDEN } from "../actions/actionTypes";

export default (state = false, action) => {
  switch (action.type) {
    case BUTTONS_SHOWN:
      return true;

    case BUTTONS_HIDDEN:
      return false;

    default:
      return state;
  }
};
